module.exports = "/_next/static/images/e089111891583e11104a36e5d5a29d56-smiley.svg.webp";